import type { IconSvgObject } from './types';

const FolderPenIcon: IconSvgObject = [
  ["path", { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V19C22 20.1046 21.1046 21 20 21H10M12.0179 6.99446L9.60016 3.79437C9.22218 3.29407 8.63144 3 8.0044 3H4C2.89543 3 2 3.89543 2 5V13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 21V18.7143L7.51225 13.202C7.64161 13.0727 7.81706 13 8 13C8.18294 13 8.35839 13.0727 8.48775 13.202L9.79797 14.5123C9.92733 14.6416 10 14.8171 10 15C10 15.1829 9.92733 15.3584 9.79797 15.4877L4.28571 21H2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FolderPenIcon;
